import React, {useState, useCallback, useEffect} from 'react';
import { useDropzone } from 'react-dropzone';
import { FaFileExcel } from 'react-icons/fa';
import * as XLSX from 'xlsx';
import Loader1 from "./Loader1";
import axios from "axios";
import {Apis} from "../util/data";
import {errorToast, successToast} from "./layout/ToastStyles";

const ExcelReader = ({setTitle,setAction}) => {
  const [data, setData] = useState([]);
  const [file, setFile] = useState(null);
  const [loading,setLoading] = useState(false);
  const [loaingExcel, setLoadingExcel] = useState(false);
  const gruposRiesgo = ["Riesgos personales","Riesgos familiares","Riesgos sociales","Riesgos ambientales"]

  useEffect(() => {
    setTitle("Subir matriz de riesgos y daños");
  }, [])

  const enviarExcel = async (datos) => {
    try {
      setLoadingExcel(true);
      const body = {hojas: datos}
      const {data} = await axios.post(Apis.PROD + "/riesgo/bulk",body)
      if (data) {
        setLoadingExcel(false);
        successToast(data)
      }
    }
    catch (error){
      setLoadingExcel(false)
      errorToast("Error al cargar el excel")
      console.log(error)
    }
  }

  useEffect(()=>{
    setAction(()=>()=> enviarExcel(data))
  },[data])

  const onDrop = useCallback((acceptedFiles) => {
    const selectedFile = acceptedFiles[0];
    setFile(selectedFile);
    const reader = new FileReader();

    reader.onload = (e) => {
      setLoading(true)
      console.log('carga inicia')
      const binaryStr = e.target.result;
      const workbook = XLSX.read(binaryStr, { type: 'binary' });

      const sheetsData = [];
      workbook.SheetNames.forEach((sheetName) => {
        console.log(sheetName)
        let rangoInicial = sheetName.split('(')[1]?.split('-')[0]?.split(' ')[0];
        if(rangoInicial === undefined) return
        const sheet = workbook.Sheets[sheetName];
        const range = XLSX.utils.decode_range(sheet['!ref']); // Obtiene el rango de celdas en la hoja

        const filteredData = [];
        let enfermedades = [];
        let agregarEnfermedad = false;
        let grupo = "";
        let pararLectura = false;
        for (let R = range.s.r; R <= range.e.r; ++R) { // Iterar sobre las filas
          const row = {riesgo:{},
            ponderacion:[],
            recomendacion:"",
            pdfs:[],
            productos:[],
            consejeria:""
          };
          let saltarFila = false;
          for (let C = range.s.c; C <= range.e.c; ++C) { // Iterar sobre las columnas
            const cellAddress = { c: C, r: R };
            const cellRef = XLSX.utils.encode_cell(cellAddress);
            const cell = sheet[cellRef];
            if(gruposRiesgo.includes(cell?.v)) {
              grupo = cell?.v
              saltarFila = true
              break
            }
            if(R === 1) {
              if(cell?.v === undefined) agregarEnfermedad = false
              else if(agregarEnfermedad) enfermedades.push(cell?.v)
              if(cell?.v === 'V') agregarEnfermedad = true
            }
            if(R > 1 && C === 0 && cell?.v === undefined) {
              pararLectura = true
              break
            }
            if(C === 0) {
              row.riesgo.riesgo = cell?.v
              row.riesgo.grupo = grupo
            }
            if(C === 1) row.riesgo.ajusteEdad = cell?.v
            if(C === 2) row.riesgo.valorSi = cell?.v
            if(C > 2 && C <= 2 + enfermedades.length) row.ponderacion.push(cell?.v)
            if(C === (4 + enfermedades.length*2)) row.recomendacion = cell?.v
            if(C > (4 + enfermedades.length*2) && C <= (4 + enfermedades.length*2 + 6) && cell?.v) row.pdfs.push(cell.v.toString())
            if(C > (10 + enfermedades.length*2) && C <= (10 + enfermedades.length*2 + 6)
              && cell?.v?.startsWith("033")) row.productos.push(cell.v)
            if(C === (17 + enfermedades.length*2) && cell?.v) row.consejeria = cell?.v
          }
          // Si toda la fila está vacía, detener la lectura
          if (pararLectura) {
            break;
          }

          if(R > 1 && !saltarFila)filteredData.push(row);
        }

        sheetsData.push({
          rangoInicial,
          enfermedades,
          riesgos: filteredData,
        });
      });

      setData(sheetsData);
      setLoading(false)
    };

    reader.readAsBinaryString(selectedFile);
  }, []);

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: '.xls,.xlsx',
  });

  const removeFile = () => {
    setFile(null);
  };

  return (
    <div style={styles.container}>
      <div {...getRootProps()} style={styles.dropzone}>
        <input {...getInputProps()} />
        {
          isDragActive ?
            <p>Suelta el archivo aquí...</p> :
            <p>Arrastra y suelta un archivo Excel aquí, o haz clic para seleccionar un archivo</p>
        }
      </div>
      {!loading ? file && (
        <div style={styles.fileInfo}>
          <FaFileExcel style={styles.icon} /> {/* Ícono para el archivo Excel */}
          <p>{file.name}</p>
          <button onClick={removeFile} style={styles.removeButton}>Quitar archivo</button>
        </div>
      ) : (
        <Loader1/>
      )
      }
      {loaingExcel && <Loader1 text={"Subiendo excel, espere por favor..."} />}
    </div>
  );
};

const styles = {
  container: {
    width: '100%',
    maxWidth: '600px',
    margin: '0 auto',
  },
  dropzone: {
    border: '2px dashed #cccccc',
    borderRadius: '5px',
    padding: '20px',
    textAlign: 'center',
    cursor: 'pointer',
    backgroundColor: '#fafafa',
    marginBottom: '10px',
  },
  fileInfo: {
    marginTop: '10px',
    display: 'flex',
    alignItems: 'center',
  },
  icon: {
    marginRight: '10px',
    fontSize: '24px',
    color: '#217346', // Color del ícono de Excel
  },
  removeButton: {
    backgroundColor: '#ff4d4d',
    border: 'none',
    color: '#fff',
    padding: '5px 10px',
    borderRadius: '5px',
    cursor: 'pointer',
    marginLeft: 'auto',
  },
};

export default ExcelReader;
